import React from 'react';
import { useActiveBlockVersionFromCookie } from '@/hooks/useActiveBlockVersionFromCookie';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import StatusPill, { StatusPillColors } from '@/components/statusPill/StatusPill';
import BlockCardStyled from './BlockCard.styled';

interface BlockCardProps {
  name: string;
  description?: string;
  defaultSelected: string;
  defaultOverridden?: boolean;
  action: (e: any) => void;
}

const BlockCard = ({
  name,
  description,
  defaultSelected,
  defaultOverridden,
  action,
}: BlockCardProps) => {
  const { branch, version } = useActiveBlockVersionFromCookie(name);
  const isOverridden = version || branch || defaultOverridden;
  const selected = branch ? `${branch}/version${version}` : defaultSelected;

  return (
    <BlockCardStyled>
      <div className="block-card__header">
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            action(e);
          }}
          className="block-card__btn"
          aria-label={`${name}-${selected}-${isOverridden ? 'overridden' : ''}`}
        >
          <h3 className="block-card__title">{name}</h3>
          <Icon icon={IconsDictionary.Chevron} width={32} height={32} />
        </a>
      </div>
      {description && <p className="block-card__description">{description}</p>}
      {(selected || isOverridden) && (
        <div
          className={`block-card__footer ${
            selected?.length >= 34 ? 'block-card__footer--wrap' : ''
          }`}
        >
          {selected && (
            <StatusPill
              text={selected}
              color={StatusPillColors.Grey}
              isHollow
            />
          )}
          {isOverridden && <span className="block-card__info">Overridden</span>}
        </div>
      )}
    </BlockCardStyled>
  );
};

export default BlockCard;
